module.exports = __webpack_public_path__ + "static/media/info.cd6b48cb.svg";